import React, { useState } from 'react';
import './menuPack.css';

import { Container, Row, Col } from 'reactstrap';
import ProductCard from '../ProductCard';

import {
    fastFoodProducts,
    riceMenuProducts,
    pizzaProducts,
    dessertProducts,
    coffeeProducts,
} from '../../assets/fake-data/products';

const menuList = [
    {
        id: 1,
        name: 'Fast Food',
        dataList: fastFoodProducts,
    },
    {
        id: 2,
        name: 'Rice Menu',
        dataList: riceMenuProducts,
    },
    {
        id: 3,
        name: 'Pizza',
        dataList: pizzaProducts,
    },
    {
        id: 4,
        name: 'Desserts',
        dataList: dessertProducts,
    },
    {
        id: 5,
        name: 'Coffee',
        dataList: coffeeProducts,
    },
];

const MenuPack = () => {
    const [showMenu, setShowMenu] = useState(fastFoodProducts);

    return (
        <section>
            <Container>
                <Row>
                    <Col lg="12" className="text-center ">
                        <h2>Our Menu Pack</h2>
                    </Col>
                    <Col lg="12" className="text-center mb-5">
                        {menuList.map((item) => (
                            <button
                                key={item.id}
                                className={showMenu === item.dataList ? 'btn active' : 'btn'}
                                onClick={() => setShowMenu(item.dataList)}
                            >
                                {item.name}
                            </button>
                        ))}
                    </Col>

                    {showMenu.map((item) => (
                        <Col lg="3" md="4" sm="6" key={item.id}>
                            <ProductCard item={item} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default MenuPack;
